{
  "alert.informative": "Informatif",
  "alert.negative": "Négatif",
  "alert.notice": "Remarque",
  "alert.positive": "Positif",
  "attachmentlist.nextAttachments": "Afficher les pièces jointes suivantes",
  "attachmentlist.previousAttachments": "Afficher les pièces jointes précédentes",
  "chat.newMessage": "Nouveau message",
  "chat.scrollToBottom": "Faire défiler vers le bas",
  "messagefeedback.thumbDown": "Réponse incorrecte",
  "messagefeedback.thumbUp": "Réponse correcte",
  "promptfield.aiDisclaimer": "Les réponses sont générées à l’aide de l’IA et peuvent être inexactes. Vérifiez avant de les utiliser.",
  "promptfield.aiUserGuidlines": "Instructions d’utilisation de l’IA",
  "promptfield.attachments": "Pièces jointes",
  "promptfield.insertButton": "Ajouter",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Vous souhaitez commencer ? Posez une question, partagez une idée ou ajoutez une tâche.",
  "promptfield.placeholder.small": "Demander quelque chose",
  "promptfield.stopButton": "Arrêter",
  "promptfield.submitButton": "Envoyer",
  "promptfield.uploading": "Chargement",
  "responsestatus.loading": "Chargement",
  "responsestatus.processing": "Traitement en cours…",
  "voicebutton.startListening": "Démarrer l’enregistrement",
  "voicebutton.stopListening": "Arrêter l’enregistrement"
}
